import * as yup from "yup";
import { isEmailValid } from "ui/components/TextField/EmailTextField/emailUtils";
import { RecipientEmail } from "./types";


export const EMAIL_SEND_MODAL_VALIDATION_SCHEMA = (
  additionalEmails: { emailAddress: string; selected: boolean }[],
  contactEmails: RecipientEmail[]
) =>
  yup.object().shape({
    newEmail: yup.string()
      .required("Molimo Vas da unesete email adresu")
      .test("valid-email", "Neispravna email adresa", (value) => {
        if (!value) return true;
        return isEmailValid(value);
      })
      .test("not-duplicate", "Email adresa već postoji", (value) => {
        if (!value) return true;
        const trimmed = value.trim().toLowerCase();
        const existsInAdditional = additionalEmails.some(
          (e) => e.emailAddress.toLowerCase() === trimmed
        );
        const existsInContact = contactEmails.some(
          (e) => e.emailAddress.toLowerCase() === trimmed
        );
        return !existsInAdditional && !existsInContact;
      }),
  });
